// src/APIs/patientInsuranceApi.js
import api from "./axios";

// Base: /api/patients/{patientId}/insurances
const base = (patientId) =>
  `/api/v1/patients/${encodeURIComponent(patientId)}/insurances`;

/**
 * DTO shape (for reference):
 * {
 *   id?: number,
 *   patientId: number,
 *   planId: string,        // e.g. "AB123"
 *   memberId: string,
 *   groupId: string,
 *   coverageStart?: string, // "YYYY-MM-DD"
 *   coverageEnd?: string,   // "YYYY-MM-DD"
 *   status?: "PENDING" | "VERIFIED" | "REJECTED",
 *   uploadedCardUrl?: string
 * }
 */

// List all insurance rows for a patient
export async function listPatientInsurances(patientId) {
  const res = await api.get(base(patientId));
  return res.data; // Array<PatientInsuranceDTO>
}

// Get one insurance row for a patient
export async function getPatientInsurance(patientId, insuranceId) {
  const res = await api.get(
    `${base(patientId)}/${encodeURIComponent(insuranceId)}`,
  );
  return res.data; // PatientInsuranceDTO
}

// Create a new insurance row for a patient
export async function createPatientInsurance(patientId, dto) {
  // Ensure patientId in payload matches route patientId (backend can also enforce)
  const payload = { ...dto, patientId };
  const res = await api.post(base(patientId), payload);
  return res.data; // PatientInsuranceDTO (created)
}

// Update an existing insurance row for a patient
export async function updatePatientInsurance(patientId, insuranceId, dto) {
  // Keep route the source of truth for patient & id
  const payload = { ...dto, id: insuranceId, patientId };

  const res = await api.put(
    `${base(patientId)}/${encodeURIComponent(insuranceId)}`,
    payload,
  );
  return res.data; // PatientInsuranceDTO (updated)
}

// Delete an insurance row for a patient
export async function deletePatientInsurance(patientId, insuranceId) {
  await api.delete(`${base(patientId)}/${encodeURIComponent(insuranceId)}`);
}

/* Optional helpers */

// Upsert: create if no id, else update
export async function upsertPatientInsurance(patientId, dto) {
  if (dto?.id) {
    return updatePatientInsurance(patientId, dto.id, dto);
  }
  return createPatientInsurance(patientId, dto);
}
